export const UPDATE_FILTER_OPTIONS='UPDATE_FILTER_OPTIONS';
export const UPDATE_ACTIVITY_COUNT='UPDATE_ACTIVITY_COUNT';


// WEBPACK FOOTER //
// ./src/reports/general/javascripts/constants.js